import { isNil } from 'lodash'

const convertBoolToBinary = (bool) => {
  if (isNil(bool)) return ''
  return +bool
}

export default convertBoolToBinary
